import { render, staticRenderFns } from "./MainNotificationComponent.vue?vue&type=template&id=5e4f4eda&scoped=true"
import script from "./MainNotificationComponent.vue?vue&type=script&lang=js"
export * from "./MainNotificationComponent.vue?vue&type=script&lang=js"
import style0 from "./MainNotificationComponent.vue?vue&type=style&index=0&id=5e4f4eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4f4eda",
  null
  
)

export default component.exports